export default __webpack_public_path__ + "static/media/sobre_1.5f36f9cb.png";